import {atom} from "recoil";
import {FormSearchLocationGroupLocationModel, LocationGroupLocations} from "../api/types/locationGroupLocation";


export const defaultSearchedLocationGroupLocation = {locationGroupName: "", locationName: "", legalEntities: []};
export const locationFiltersLocationAtom = atom<FormSearchLocationGroupLocationModel>({
    key: "searchedLocationGroupLocationAtom",
    default: defaultSearchedLocationGroupLocation
});

export const selectedLocationGroupLocationAtom = atom<LocationGroupLocations | null>({
    key: "selectedLocationGroupLocationAtom",
    default: null
});
